export const API_BASE_URL =
  // "https://test-api.coachli.co/api/v1/";
  process.env.REACT_APP_APP_ENV === "production"
    ? process.env.REACT_APP_API_BASE_URL_LIVE
    : process.env.REACT_APP_API_BASE_URL_DEV;

export const API_BASE_URL_V2 =
  process.env.REACT_APP_APP_ENV === "production"
    ? process.env.REACT_APP_API_BASE_URL_LIVE_V2
    : process.env.REACT_APP_API_BASE_URL_DEV_V2;

function normalizePublicSiteBaseUrl(raw: string): string {
  return raw.trim().replace(/\/+$/, "");
}

/**
 * Base URL for share links and public paths (`{base}/{username}/…`).
 *
 * Priority:
 * 1. `REACT_APP_REBRAND_BASE_URL` — override in CI if needed.
 * 2. Otherwise default by `REACT_APP_APP_ENV`: production vs non-production.
 */
const configuredPublicBase = process.env.REACT_APP_REBRAND_BASE_URL?.trim();
export const REBRAND_BASE_URL = normalizePublicSiteBaseUrl(
  configuredPublicBase ||
    (process.env.REACT_APP_APP_ENV === "production"
      ? "https://dashboard.coachli.co"
      : "https://staging-v2.coachli.co")
);

export const IS_INTEGRATIONS_FEATURE_ENABLED =
  process.env.REACT_APP_V2_INTEGRATIONS_FEATURE_ENABLED === "true";

export const IS_TELEGRAM_INTEGRATION_ENABLED =
  process.env.REACT_APP_TELEGRAM_INTEGRATION_ENABLED === "true";

export const IS_PHYSICAL_LOCATION_FEATURE_ENABLED =
  process.env.REACT_APP_PHYSICAL_LOCATION_FEATURE_ENABLED === "true";

export const IS_PUBLIC_PROFILE_BUILDER_ENABLED =
  process.env.REACT_APP_PUBLIC_PROFILE_BUILDER_ENABLED === "true";

/**
 * Pay What You Want pricing. Defaults off; remove this flag once the feature is stable.
 */
export const IS_PWYW_ENABLED = process.env.REACT_APP_PWYW_ENABLED === "true";

/**
 * Kill switch for two-factor auth. Off in production until the backend side is
 * ready to ship again — 2FA reached prod ahead of that and had to be pulled.
 *
 * Gates every entry point into the feature: the post-login setup nudge, the
 * settings section, and the get-started step. With it off the app offers 2FA
 * nowhere, so turning the feature back on is an env var rather than a revert.
 *
 * The login challenge and the withdrawal code step are deliberately outside it.
 * Both follow the account's real 2FA state on the backend: a coach who already
 * has 2FA on can't log in or withdraw without a code.
 */
export const IS_TWO_FACTOR_FEATURE_ENABLED =
  process.env.REACT_APP_TWO_FACTOR_FEATURE_ENABLED === "true";

export const getGoogleCalendarSettingsPath = () =>
  "/automations/integrations/google-calendar";
